import { CPR_AUTH, CPR_BROWSERID, FAF_AUTH, FAF_BROWSERID, PARTNER_AUTH } from "../../constant/Constants";
import axiosCall from "../axiosCall";
import { resetSessionTiming } from "../sessionManagement";


//Application Submission
export const submitApplication = async ({ createApp, prgData }) => {
    resetSessionTiming()
    const authorization = prgData == 'CPR' ? CPR_AUTH : FAF_AUTH;
    let browserID = prgData == 'CPR' ? CPR_BROWSERID : FAF_BROWSERID;
    const response = await axiosCall('post', `/Applications/v1/App?`, authorization, `BrowserID=${browserID}`, createApp, prgData);
    return { res: response.data, program: prgData }
}

// Update Patient in Partner Portal
export const updatePatient = async ({ reqBody, browserId, portalUserId, prgData }) => {
    resetSessionTiming()
    const response = await axiosCall('post', `/Partner/v1/CreatePatient/?`, PARTNER_AUTH, `BrowserID=${browserId}&PortalUserID=${portalUserId}`, reqBody, prgData);
    return response.data
}

// get provider details

export const searchProviders = async ({ prgData, provider }) => {
    resetSessionTiming()
    const authorization = prgData == 'CPR' ? CPR_AUTH : FAF_AUTH;
    let browserID = prgData == 'CPR' ? CPR_BROWSERID : FAF_BROWSERID;
    const City = provider.City ? provider.City : "";
    const State = provider.State ? provider.State : "";
    const FirstName = provider.FirstName ? provider.FirstName : "";
    const LastName = provider.LastName ? provider.LastName : "";
    const FacilityName = provider.FacilityPracticeName ? provider.FacilityPracticeName : "";
    const ZipCode = provider.pyPostalCode ? provider.pyPostalCode : "";
    const NPI = provider.ProviderNPINbr ? provider.ProviderNPINbr : "";
    const MaxRows = 50;
    const NPIType = provider.Claim ? '' : '1';
    let params = `NPIType=${NPIType}&City=${City}&FacilityName=${FacilityName}&State=${State}&FirstName=${FirstName}&LastName=${LastName}&ZipCode=${ZipCode}&MaxRows=${MaxRows}&NPI=${NPI}`
    const response = await axiosCall('get', `/v1/data/D_SearchProviders?`, authorization, params, null, prgData);
    return response.data
}
export const getProviderAddress = async ({ prgData, NPI, provider }) => {
    resetSessionTiming()
    const authorization = prgData == 'CPR' ? CPR_AUTH : FAF_AUTH;
    let params = `NPI=${NPI}`
    const response = await axiosCall('get', `/v1/data/D_OpenProvider?`, authorization, params, null, prgData);
    return response.data
}

export const getFormularyDetails = async ({ prgData, fundId, searchText = "" }) => {
    resetSessionTiming()
    const authorization = prgData == 'CPR' ? CPR_AUTH : FAF_AUTH;
    let params = `FundID=${fundId}&SearchDrug=${searchText}`;

    const response = await axiosCall('get', `/v1/data/D_GetFormularyDetails?`, authorization, params, null, prgData);
    return response.data
}
